export default {
  sm: 'h-[37px] px-sm ---',
  md: 'h-[44px] px-md',
  lg: '',
}
